import { useLocation } from "react-router-dom";
import { useBuildingStore } from "./useBuildingStore";

/**
 * Determines the correct back navigation destination based on
 * the current route context and last visited building.
 *
 * - Inside a building (`/buildings/:id/*`) → go to `/buildings`
 * - On settings/org-settings pages → go to last visited building (or `/buildings`)
 * - On admin pages → go to `/buildings`
 * - Default fallback → `/buildings`
 */
export function useSmartBack(): { backTo: string } {
  const location = useLocation();
  const buildingStore = useBuildingStore();
  const { pathname } = location;

  // Inside a building — back goes to the building list
  if (/^\/buildings\/[^/]+/.test(pathname)) {
    return { backTo: "/buildings" };
  }

  // Settings or organization settings — return to last visited building
  if (pathname === "/settings" || pathname === "/organization-settings") {
    const lastId = buildingStore.lastVisitedBuildingId;
    if (lastId) {
      return { backTo: `/buildings/${lastId}` };
    }
    return { backTo: "/buildings" };
  }

  // Admin pages — back to buildings
  if (pathname.startsWith("/admin")) {
    const lastId = buildingStore.lastVisitedBuildingId;
    if (lastId) {
      return { backTo: `/buildings/${lastId}` };
    }
    return { backTo: "/buildings" };
  }

  // Default fallback
  return { backTo: "/buildings" };
}
